var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"login-with-google",class:{'custom-link': _vm.isCustomLink, 'button-container': !_vm.isCustomLink}},[_vm._t("default"),_c('div',{ref:"hiddenContainer",staticClass:"d-none"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }